<template>
	<portal to="modal-container">
		<transition name="fade">
			<div v-show="isVisible" class="fixed z-50 w-full h-full top-0 left-0 flex items-center justify-center text-gray-800">
				<div class="modalBackground" />
				<div class="relative mx-auto z-50 w-full p-8 justify-center" :class="modalClass || 'xxl:w-2/3'" :style="modalStyle">
					<BaseCard
						class="modalSlotWrapper overflow-y-auto bg-white"
						:title="title"
						:is-toggleable="false"
						@close="cancel"
						:is-modal="true"
						:hint="hint"
					>
						<template #preTitle>
							<slot name="preTitle"></slot>
						</template>
						<slot></slot>
					</BaseCard>
				</div>
			</div>
		</transition>
	</portal>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import AppContainerMixin from '@/mixins/AppContainerMixin';

export default {
	name: 'BaseModal',
	components: { BaseCard },
	mixins: [AppContainerMixin],
	emits: ['cancel'],
	props: {
		modalClass: {},
		hint: { type: String },
		modalStyle: { required: false },
		order: {
			type: Number,
			required: true,
		},
		init: {
			type: Function,
			default: () => {},
		},
		title: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			initialized: false,
			isVisible: false,
			promiseResolve: Object,
			scrollPosition: 0,
		};
	},
	methods: {
		show() {
			if (!this.initialized) {
				this.init();
				this.initialized = true;
			}
			this.isVisible = true;
			this.$nextTick(() => {
				this.enable();
			});

			return new Promise(resolve => (this.promiseResolve = resolve));
		},
		cancel() {
			this.disable();
			this.$emit('cancel');
		},
		hide(action) {
			this.disable();
			this.isVisible = false;
			this.promiseResolve(action);
		},
		enable() {
			this.scrollPosition = window.pageYOffset;
			document.documentElement.classList.add('disableScroll');
			document.documentElement.style.top = `-${this.scrollPosition}px`;
		},
		disable() {
			document.documentElement.classList.remove('disableScroll');
			document.documentElement.style.removeProperty('top');
			window.scrollTo(0, this.scrollPosition);
		},
	},
	destroyed() {
		this.disable();
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.25s;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.modalSlotWrapper {
	max-height: calc(100vh - 4rem);
}

.modalBackground {
	@apply absolute w-full h-full bg-gray-900 bg-opacity-50;
	backdrop-filter: blur(4px);
}
</style>
